import {Store} from "vuex";
import {UserProfile} from "@api/models/UserProfile";
import {presentersGetter, removedSpeakersGetter} from "@share/web-conferences/store/getters";
import {isSchemaMeeting} from "@share/web-conferences/helpers/isSchemaMeeting";
import {StoreHelper} from "@share/web-conferences/helpers/StoreHelper";
import VueRouter from "vue-router";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { WebConferenceService } from "@share/web-conferences/data/WebConferenceService";

export class SpeakerChecker {
    constructor(
        private readonly storeHelper: StoreHelper,
        private speakers: UserProfile[],
        private readonly schemaId: string,
        private readonly isAdmin: boolean,
        private readonly currentUserId: number,
        private readonly router: VueRouter,
        private readonly webConferencesService: WebConferenceService
    ) {
    }

    private getPresentersFromTheStore() {
        return this.storeHelper.store.getters[presentersGetter](this.storeHelper.stateKey);
    }

    private getRemovedSpeakersFromTheStore(): number[] {
        return this.storeHelper.store.getters[removedSpeakersGetter](this.storeHelper.stateKey);
    }

    addSpeaker(userProfile: UserProfile) {
        if (this.speakers.findIndex(item => item.userId == userProfile.userId) < 0) {
            this.speakers.push(userProfile);
        }
    }

    isSpeaker(userId: number): boolean {
        //@todo think of a better way to resolve that
        if (this.router.currentRoute.name == RouteNamesEnum.viewMeetingPublicRecording && this.currentUserId == userId) {
            return false;
        }

        if (this.webConferencesService.webConferenceData?.recordingUserIds.includes(userId)) {
            return false;
        }

        const removedSpeakers = this.getRemovedSpeakersFromTheStore();
        const haystack = [...this.speakers, ...this.getPresentersFromTheStore()]
            .filter(item => removedSpeakers.indexOf(item.userId) < 0)
            .map(item => item.userId);

        const isAdmin = this.isAdmin && this.currentUserId === userId;
        const isMeeting = (isSchemaMeeting(this.schemaId) && !isAdmin);
        //@todo figure out  way to checck meetings users which come from direct links

        return isMeeting || haystack.findIndex(item => item == userId) >= 0;
    }

    isInOriginalSpeakersList(userId: number): boolean {
        return this.speakers.findIndex(item => item.userId == userId) >= 0;
    }
}
